module.exports = __webpack_public_path__ + "img/upload.86bcb1b9.png";